module.exports = __webpack_public_path__ + "img/re_event3.e197c02d.png";